// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"a563bf4cd2ea84497355","691":"7b90f2e1a01a824cebee"}[chunkId] + ".js";
};